import api from '../api/axiosInstance';
import { AutomationFlow } from '../types/automation-flow.types';

export interface AutomationFlowFilters {
  status?: string;
  name?: string;
  cardName?: string;
  environment?: string;
  description?: string;
  productLine?: string;
  createdAt?: string;
}

export interface PaginatedAutomationFlowResponse {
  data: AutomationFlow[];
  total: number;
  limit: number;
  offset: number;
  nextPage: string | null;
}

export const automationFlowService = {
  getAll: async (
    page: number = 1,
    limit: number = 10,
    filters: AutomationFlowFilters = {},
    sortBy: string = 'createdAt',
    sortOrder: 'ASC' | 'DESC' = 'DESC'
  ): Promise<PaginatedAutomationFlowResponse> => {
    const params = { page, limit, sortBy, sortOrder, ...filters };
    const response = await api.get('/api/automation-flow/paginated', { params });
    return response.data;
  },
  getById: (id: string) => api.get(`/api/automation-flow/${id}`),
  create: (data: unknown) => api.post('/api/automation-flow', data),
  update: (id: string | undefined, data: unknown) => api.put(`/api/automation-flow/${id}`, data),
  delete: (id: string) => api.delete(`/api/automation-flow/${id}`),
};
